import Seo, { breadcrumb } from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/motion";
import { SITE } from "@/data/content";

const CONTENT = {
  privacy: {
    label: "Privacy Policy",
    overline: "Your privacy",
    titleLines: ["Privacy", "Policy."],
    path: "/privacy",
    intro: "How Cranio Cove handles the information you choose to share with us.",
    sections: [
      { h: "Information we collect", p: "When you use the contact form, we collect the details you provide, such as your name, email, optional phone number, preferred appointment type and message, solely to respond to your enquiry." },
      { h: "How we use your information", p: "Your information is used only to reply to you and to arrange sessions. We do not sell or share your personal details with third parties for marketing purposes." },
      { h: "Storing your information", p: "Enquiry details are stored securely and kept only as long as necessary to support your care and comply with any legal obligations. You may request that we delete your information at any time." },
      { h: "Sensitive information", p: "Please do not submit private medical details through the general contact form. Any health information relevant to your sessions is discussed and recorded confidentially as part of your intake." },
      { h: "Contact", p: `To ask about your information or request its removal, email ${SITE.email}. [Placeholder, Laura may add further detail once confirmed.]` },
    ],
  },
  terms: {
    label: "Terms & Conditions",
    overline: "The essentials",
    titleLines: ["Terms &", "Conditions."],
    path: "/terms",
    intro: "The simple terms that apply when you book and attend a session at Cranio Cove.",
    sections: [
      { h: "Bookings", p: "Sessions are booked by mutual arrangement following your enquiry. A session is confirmed once Laura has replied and agreed a time with you." },
      { h: "Cancellations", p: "Please provide at least [24] hours' notice to reschedule or cancel. [Placeholder, any cancellation fee or policy detail can be added here.]" },
      { h: "Nature of the service", p: "Craniosacral therapy is a complementary practice offered for relaxation and general wellbeing. It does not diagnose, treat or cure medical conditions and is not a substitute for medical care." },
      { h: "Your responsibilities", p: "You're asked to share relevant information honestly during intake and to let Laura know of any changes to your health or comfort during a session." },
      { h: "Changes to these terms", p: "These terms may be updated from time to time. [Placeholder, final terms to be confirmed by Laura.]" },
    ],
  },
  accessibility: {
    label: "Accessibility",
    overline: "Everyone welcome",
    titleLines: ["Accessibility", "Statement."],
    path: "/accessibility",
    intro: "Cranio Cove is committed to a website and a practice that feel welcoming and usable for everyone.",
    sections: [
      { h: "Our commitment", p: "We aim to meet recognised accessibility standards, with clear structure, readable text, strong colour contrast, descriptive alt text and full keyboard navigation across the website." },
      { h: "At the practice", p: "[Placeholder, physical accessibility details for the treatment space will be confirmed here. Please get in touch about any access needs and Laura will talk through arrangements.]" },
      { h: "Feedback", p: `If you experience any difficulty using this website or visiting the practice, please email ${SITE.email} so we can help and continue to improve.` },
    ],
  },
};

export default function Legal({ kind }) {
  const data = CONTENT[kind] || CONTENT.privacy;
  return (
    <>
      <Seo
        title={data.label}
        description={`${data.label} for Cranio Cove, ${data.intro}`}
        path={data.path}
      />
      <PageHero
        overline={data.overline}
        titleLines={data.titleLines}
        intro={data.intro}
        breadcrumb={breadcrumb([{ name: "Home", path: "/" }, { name: data.label, path: data.path }])}
      />
      <section className="px-6 md:px-12 pb-28 md:pb-40" data-testid={`legal-${kind}`}>
        <div className="mx-auto max-w-3xl divide-y divide-cove-slate/15 border-t border-cove-slate/15">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="py-10">
                <h2 className="font-serif text-3xl text-cove-slate">{s.h}</h2>
                <p className="mt-4 text-lg leading-relaxed text-cove-olive">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
